import {
  fetchUserRepo,
  getCreateUserRepo,
  postCreateUserRepo,
  postValidateFieldsRepo,
  logoutUserRepo,
  userPushToLSQRepo,
} from "../../repositories/user/user";
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import axios from "axios";
import {certificationPage } from "../../../client/utils/registrationUtils";

const userSlice = createSlice({
  name: "userReducer",
  initialState: {
    loading: false,
    user: null,
    user_error: null,
    createUserLoading: null,
    createUser: null,
    createUserError: null,
    postCreateUserResponse: null,
    postCreateUserError: null,
    validateLoading: null,
    validate: null,
    validateError: null,
    userResolved: false,
    userLogout: null,
    pushToLsq:null,
    pushToLsqError:null,
    pushToLsqLoading:false,
  },
  reducers: {
    Loading(state, action) {
      return {
        ...state,
        loading: true,
        // isLogout: false
      };
    },
    setUserInState(state, action) {
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    },
    tokenError(state, action) {
      return {
        ...state,
        loading: false,
        user: null,
        user_error: action.payload,
      };
    },
    getCreateUserLoading(state, action) {
      return {
        ...state,
        createUserLoading: true,
      };
    },
    getCreateUserSuccess(state, action) {
      return {
        ...state,
        createUserLoading: false,
        createUser: action.payload,
      };
    },
    getCreateUserFailure(state, action) {
      return {
        ...state,
        createUserLoading: false,
        createUserError: action.payload,
      };
    },
    postCreateUserSuccess(state, action) {
      return {
        ...state,
        postCreateUserResponse: action.payload,
      };
    },
    postCreateUserFailure(state, action) {
      return {
        ...state,
        postCreateUserError: action.payload,
      };
    },
    clearPostCreateUserSuccess(state, action) {
      return {
        ...state,
        postCreateUserResponse: null
      };
    },
    validatesRequest(state, action) {
      return {
        ...state,
        validateLoading: true,
      };
    },
    validateSuccess(state, action) {
      return {
        ...state,
        validateLoading: false,
        validate: action.payload,
      };
    },
    validateFailure(state, action) {
      return {
        ...state,
        validateLoading: false,
        validate: null,
        validateError: action.payload,
      };
    },
    getLogoutSuccess(state, action) {
      return {
        ...state,
        userLogout: action.payload,
        user: null,
      };
    },
    pushToLSQLoading(state, action) {
      return {
        ...state,
        pushToLsqLoading: true,
      };
    },
    pushToLSQSuccess(state, action) {
      return {
        ...state,
        pushToLsqLoading: false,
        pushToLsq: action.payload,
      };
    },
    pushToLSQFailure(state, action) {
      return {
        ...state,
        pushToLsqLoading: false,
        pushToLsq: null,
        pushToLsqError: action.payload,
      };
    },

  },
});
export const {
  Loading,
  setUserInState,
  tokenError,
  getCreateUserLoading,
  getCreateUserSuccess,
  getCreateUserFailure,
  postCreateUserSuccess,
  postCreateUserFailure,
  clearPostCreateUserSuccess,
  validatesRequest,
  validateSuccess,
  validateFailure,
  getLogoutSuccess,
  pushToLSQLoading,
  pushToLSQSuccess,
  pushToLSQFailure
} = userSlice.actions;

export const fetchUser = (params) => {
  const cookies = new Cookies();
  let sessionKey = ''

  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes("SESS") && !value?.includes("CSESS360"))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey)
  return (dispatch) => {
    dispatch(Loading(false));
    fetchUserRepo(sessionValue)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(setUserInState(response?.data));
        }
      })
      .catch((error) => {
        dispatch(tokenError("User Not Authenticated"));
      });
  };
};

export const getCreateUser = (params) => {
  return (dispatch) => {
    dispatch(getCreateUserLoading());
    getCreateUserRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCreateUserSuccess(response?.data?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCreateUserFailure(error.message));
        }
      });
  };
};

export const postCreateUser = (data, params) => {
  return (dispatch) => {
    postCreateUserRepo(data, params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(postCreateUserSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postCreateUserFailure(error.message));
        }
      });
  };
};
export const postValidateFields = (data) => {
  return (dispatch) => {
    dispatch(validatesRequest(false));
    postValidateFieldsRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(validateSuccess(response?.data));
        } else {
          dispatch(validateFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(validateFailure(error?.message));
        }
      });
  };
};

export const logoutUser = (params, type) => {
  const cookieDomain = window.location.hostname === 'localhost' ? window.location.hostname : axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
    return (dispatch) => {
      dispatch(Loading());
      logoutUserRepo()
        .then((response) => {
          const cookies = new Cookies();
          const allCookies = cookies.getAll();
          const subDomainName = window.location.host?.split(".")[0];
          let url = window.location.pathname;
  
          Object.keys(allCookies)?.map((value, index) => {
            if (value?.includes("CSESS360") || value?.includes("SESS"))
              cookies.remove(value, { path: "/", domain: cookieDomain });
          });
          cookies.remove("c360_jwt_refresh", { path: "/", domain: cookieDomain });
          cookies.remove("c360_jwt_access", { path: "/", domain: cookieDomain });
          cookies.remove("rgData", { path: "/", domain: cookieDomain });
          cookies.remove(`${subDomainName}-${certificationPage(url)}-rgData`, { path: "/", domain: cookieDomain })
          cookies.remove("sessionid", { path: "/", domain: cookieDomain });
          cookies.remove("adb_id", { path: "/", domain: cookieDomain });
          cookies.remove(`embedPriorityBlock_${window.location.pathname}`, {
            path: "/",
            sameSite: "Lax",
            domain: cookieDomain,
        });
          sessionStorage.removeItem("loginState");
          dispatch(getLogoutSuccess(response?.data?.data));
  
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(Loading());
          }
        });
    };
  };

  export const postUserPushToLSQ = (data) => {
  return (dispatch) => {
    dispatch(pushToLSQLoading(false));
    return userPushToLSQRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(pushToLSQSuccess(response?.data));
        } else {
          dispatch(pushToLSQFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(pushToLSQFailure(error?.message));
        }
      });
  };
};
export default userSlice.reducer;
